import React from 'react';
import { StreamingMoney } from 'fym-shared/src/music24/streaming';
import { TypedMemo } from '../../../common/types';
import { MoneyAmount } from './MoneyAmount';

interface MoneyListProps {
  amounts: StreamingMoney[] | undefined;
}

/** The net of each currency, one under the other. Two currencies are never added. */
const MoneyListComponent: React.FC<MoneyListProps> = ({ amounts }) => {
  if (amounts === undefined || amounts.length === 0) {
    return <>—</>;
  }
  return (
    <span className="d-inline-flex flex-column align-items-end">
      {amounts.map((amount) => (
        <MoneyAmount key={amount.currency ?? 'none'} value={amount.net} currency={amount.currency} />
      ))}
    </span>
  );
};

export const MoneyList = TypedMemo(MoneyListComponent);
